import FileChooser from '../widgets/file-chooser/FileChooser';
import ActionFile, { ActionFileProps, ExportData } from './ActionFile';

export interface UpdateFileProps extends ActionFileProps {
  filename: string;
  version?: string;
  downloadLink?: string;
  onUpdate: (data: ExportData) => void;
  onDelete: () => void;
}

class UpdateFile extends ActionFile<UpdateFileProps, any> {

  static getDerivedStateFromProps(props: any, currentState: any) {
    let changes: any = {};
    if (props.filename && currentState.filename !== props.filename) {
      changes.filename = props.filename;
    }
    if (props.version && currentState.version !== props.version) {
      changes.version = props.version;
    }
    if (props.freez && currentState.freez !== props.freez) {
      changes.freez = props.freez;
    }
    if (Object.keys(changes).length !== 0) {
      return changes;
    }
    return null;
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-xl-7 col-lg-12 pl-xl-0 mr-auto">
            <input
              disabled
              type="text"
              placeholder="نام فایل"
              value={this.state.filename}
              className={'form-control text-center' + this.invalidCheckClass('filename')}
              onChange={this.handleFilenameChange}
            />
          </div>
          <div className="col-xl-3 col-7 mr-xl-0 mr-auto mt-xl-0 mt-2">
            <input
              disabled
              type="text"
              placeholder="ورژن"
              value={this.state.version}
              className={'form-control text-center' + this.invalidCheckClass('version')}
              onChange={this.handleVersionChange}
            />
          </div>
          <div className="col-xxl-1 col-lg-2 col-3 px-0  ml-auto mt-xl-0 mt-2">
            <a href={this.props.downloadLink}>
              <button className="ant-btn btn-sm h-100">
                <i className="far fa-download"></i>
              </button>
            </a>
          </div>
        </div>
        <div className="row mt-4 h-100">
          <div className="col-11 mx-auto d-flex flex-column">
            <FileChooser onChoose={this.handleFileChange} invalid={!!this.state.errors.file} />
            <div className="form-group mt-auto">
              <button
                onClick={this.handleUpdate}
                disabled={this.freezDisabled('update')}
                className="btn btn-flex btn-app col-12 mt-5">
                {this.renderFreez('update')}
                بروزرسانی فایل
              </button>
              <button
                onClick={this.handleDelete}
                disabled={this.freezDisabled('delete')}
                className="btn btn-flex btn-danger col-12 mt-2">
                {this.renderFreez('delete')}
                حذف فایل
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  private handleUpdate = () => {
    if (this.validate()) {
      const { errors, ...rest } = this.state;
      rest.oldName = this.state.filename;
      this.props.onUpdate(rest);
    }
  }

  private handleDelete = () => {
    this.props.onDelete();
  }

}

export default UpdateFile;
